import gql from 'graphql-tag';

const RecommendedProductFields = gql`
	fragment RecommendedProductFields on RecommendedProduct {
		brandName
		title
		modelNumber
		id
		image {
			id
			description
			imageType
		}
		price
		ratingValue
		url
		variationsId
		parentId
		variantId
		variantName
	}
`;

/**
 * Used for getting recommendations via an API campaign in Dynamic Yield
 */
export const RECOMMENDATIONS = gql`
	${RecommendedProductFields}
	query Recommendations($id: Int!, $campaign: String!, $location: String!, $dyid: String, $dyjsession: String, $usePlaLinks: Boolean) {
		recommendations(
			id: $id
			campaign: $campaign
			location: $location
			dyid: $dyid
			dyjsession: $dyjsession
			usePlaLinks: $usePlaLinks
		) {
			...RecommendedProductFields
		}
	}
`;

/**
 * Used for reporting engagement/interaction with a recommendation via an API campaign in Dynamic Yield
 */
export const REPORT_RECOMMENDATION_ENGAGEMENT = gql`
	mutation ReportRecommendationEngagement($slotId: String!, $dyid: String, $dyjsession: String) {
		reportRecommendationEngagement(slotId: $slotId, isHybridCampaign: true, dyid: $dyid, dyjsession: $dyjsession)
	}
`;

/**
 * Used for reporting custom events via an API campaign in Dynamic Yield
 */
export const REPORT_EVENT = gql`
	mutation ReportEvent($name: String!) {
		reportEvent(name: $name)
	}
`;
